import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import { ServingsModal } from './servings_modal';

interface MealBasketButtonProps {
  isInMealBasket: boolean;
  isAddingMealsToBasket: boolean;
  askForServings: boolean;
  onAddToMealBasket: (servings: number | null | undefined) => void;
  onRemoveFromMealBasket: () => void;
}

export const MealBasketButton = ({
  isInMealBasket,
  isAddingMealsToBasket,
  askForServings = false,
  onAddToMealBasket,
  onRemoveFromMealBasket,
}: MealBasketButtonProps) => {
  const [servingsModalAnchorEl, setServingsModalAnchorEl] =
    React.useState<HTMLElement | null>(null);

  if (isInMealBasket) {
    return (
      <Tooltip
        title="Don't add this meal to shopping list"
        placement="top-start">
        <IconButton
          aria-label="remove from shopping list"
          size="small"
          onClick={(ev) => {
            onRemoveFromMealBasket();
            ev.stopPropagation();
          }}>
          <ShoppingCartIcon />
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <>
      <Tooltip title="Add this meal to a shopping list" placement="top-start">
        <IconButton
          aria-label="add to shopping list"
          size="small"
          onClick={(ev) => {
            ev.stopPropagation();
            if (askForServings) {
              setServingsModalAnchorEl(ev.currentTarget);
              return;
            }
            onAddToMealBasket(undefined);
          }}>
          <AddShoppingCartIcon />
        </IconButton>
      </Tooltip>
      {servingsModalAnchorEl && (
        <ServingsModal
          anchorEl={servingsModalAnchorEl}
          isLoading={isAddingMealsToBasket}
          onSubmit={async (servings) => {
            try {
              await onAddToMealBasket(servings);
            } finally {
              setServingsModalAnchorEl(null);
            }
          }}
          onDismiss={() => setServingsModalAnchorEl(null)}
        />
      )}
    </>
  );
};
